import { readTextFile } from '../utils/readJson.js'
import { createAndAddGenericElement, createCenteredUnderlinedText } from './generics.js'
import { createAccordionElem } from './accordianList.js'

const populateFaqList = (faqSection, jsonFile) => {
    readTextFile(jsonFile, function(readFaqList) {
        const faqListData = JSON.parse(readFaqList)
        const containerDiv = createAndAddGenericElement(["container"], "", "", "",  "div")
        createCenteredUnderlinedText(faqListData.faqs.faqHeading, "h2", containerDiv)
        const divRow = createAndAddGenericElement(["row", "justify-content-center"], "", "", "", "div")    // div row
        const divCol = createAndAddGenericElement(["col-lg-8", "faq-left"], "", "", "", "div")                                      // div col
        // accordion
        const TOTAL_ACCORDIONS = faqListData.faqs.faqList.length
        createAccordionElem(faqListData.faqs.faqList, divCol, 0, TOTAL_ACCORDIONS, false, true)
        divRow.appendChild(divCol)
        containerDiv.appendChild(divRow)
        faqSection.appendChild(containerDiv)
    })
}

export { populateFaqList }